import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NToggle, ToggleService } from '@df/ui/toggle/toggle.service';

@Component({
    selector: '[tabsContent]',
    templateUrl: './tabs-content.html',
    styleUrls: ['./tabs-content.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TabsContentComponent implements OnInit, OnDestroy {
    /**
     * Tab identifier
     */
    @Input()
    tabsContent?: NToggle.TId;

    constructor(private toggleService: ToggleService) {}

    ngOnInit() {
        if (this.tabsContent) {
            this.toggleService.register(this.tabsContent);
            this.toggleService.getGroup(this.tabsContent).openAny();
        }
    }

    ngOnDestroy(): void {
        if (this.tabsContent) {
            this.toggleService.unregister(this.tabsContent);
            this.toggleService.getGroup(this.tabsContent)?.openAny();
        }
    }
}
